import { useEffect } from 'react'
import { useToast } from '../../hooks/use-toast'
import { X } from 'lucide-react'

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed top-4 right-4 z-[100] flex max-h-screen w-full flex-col gap-2 p-4 md:max-w-[420px]">
      {toasts.map(function ({ id, title, description, variant }) {
        const props: ToastProps = {
          id,
          onDismiss: () => dismiss(id),
        }
        if (title) props.title = title
        if (description) props.description = description
        if (variant) props.variant = variant

        return <Toast key={id} {...props} />
      })}
    </div>
  )
}

interface ToastProps {
  id: string
  title?: string
  description?: string
  variant?: 'default' | 'destructive'
  onDismiss: () => void
}

function Toast({ id, title, description, variant, onDismiss }: ToastProps) {
  // Auto dismiss after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss()
    }, 5000)

    return () => clearTimeout(timer)
  }, [id, onDismiss])

  return (
    <div
      className={`group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-lg border p-4 pr-8 shadow-lg transition-all animate-in slide-in-from-top-full ${
        variant === 'destructive'
          ? 'border-red-500 bg-red-50 text-red-900'
          : 'border-gray-200 bg-white'
      }`}
    >
      <div className="grid gap-1 flex-1">
        {title && <div className="text-sm font-semibold">{title}</div>}
        {description && (
          <div className="text-sm opacity-90">{description}</div>
        )}
      </div>
      <button
        onClick={onDismiss}
        className="absolute right-2 top-2 rounded-md p-1 text-gray-500 opacity-70 transition-opacity hover:opacity-100 focus:opacity-100 focus:outline-none"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}

